import Vue from 'vue';
import MCustomerSelect from '@/components/product/customer-select.vue';
import MBuildingSelect from '@/components/product/building-select.vue';
import MMettingSelect from '@/components/product/metting-select.vue';

Vue.component(MCustomerSelect.name, MCustomerSelect);
Vue.component(MBuildingSelect.name, MBuildingSelect);
Vue.component(MMettingSelect.name, MMettingSelect);



// WEBPACK FOOTER //
// ./src/component.js